import React from 'react';
import './Featblow.css';

const Featblow = () => {
  return (
    <div className="Featblows-container">
      <h2 className="Featblows-heading">FEATURES</h2>

        <ul className="Featblows-list">
          <li>Toggle balance clamping structure, with platen opening & clamping and mold platen movement by linear guide, to achieve low friction and high speed</li>
          <li> Based on the Finite Element Analysis design, and platen, toggle and platen frame made in high intensity nodular cast iron.</li>
          <li> High speed mold clamping oil cylinder with differential speed function, and high speed mold moving cylinder with special anti-shock cushion valve structure.</li>
          <li>Specially designed screw with high L/D ratio insures good plasticizing and stable extrusion; high precision and no part line die head guarantees customers’ top quality requirement.</li>
          <li>Multi-screw & multi-die head can be adopted to improve the quality of the product and lower down the cost of material.</li>
          <li>Multiple-way PID controlled temperature heating is precise and stable.</li>
        </ul>
      </div>
  );
};

export default Featblow;
